import {
    FETCH_USER_DETAILS_REQUEST,
    FETCH_USER_DETAILS_SUCCESS,
    FETCH_USER_DETAILS_FAILURE,
  } from "./FetchUserdetailsTypes";
  
  const initialState = {
    loading: false,
    userDetails: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_USER_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_USER_DETAILS_SUCCESS:
        return {
          loading: false,
          userDetails: action.payload,
          error: "",
        };
      case FETCH_USER_DETAILS_FAILURE:
        return {
          loading: false,
          userDetails: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  